import { getSVG } from './components/icons-loader.js';
import { slickSliderGenerator, displayBrandSliderOnLoad} from './components/sliders.js';
import { handleDemoFormOrBot } from './components/get-a-demo.js';

document.addEventListener("DOMContentLoaded", function () {
  slickSliderGenerator('brand', '.logos-container');
  slickSliderGenerator('features', '.features-container');
  displayBrandSliderOnLoad();
  getSVG();
  handleDemoFormOrBot();
});
